<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.phoneType}">
      <select name="phoneType" :value="phoneType" class="form-control" @change="handleChange">
        <option value="" selected="selected">
          Select a Phone
        </option>
        <option v-for="(type, $id) in configuredPhoneTypes" :value="$id">
          {{ type }}
        </option>
      </select>
    </div>
    <div :class="{'has-error':errors.validationCriteria}">
      <select name="validationCriteria" :value="validationCriteria" class="form-control" @change="handleChange">
        <option value="" selected="selected">
          Select a validation criteria
        </option>
        <option v-for="(choiceValue, choiceKey) in validationCriteriaChoices" :value="choiceKey">
          {{ choiceValue }}
        </option>
      </select>
    </div>
  </div>
</template>
<script type="text/javascript">
import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
import {capitalize} from "@/EventLogic/util";

export default {
  filters: {
    capitalize
  },
  extends: BaseComponent,
  props: {
    phoneType: String,
    validationCriteria: String,
    id: String
  },
  data() {
    return {
      validationCriteriaChoices: {
        is_valid: 'Is valid',
        is_not_valid: 'Is not valid',
        is_mobile: 'Is mobile',
        is_not_mobile: 'Is not mobile'
      }
    }
  },
  computed: {
    configuredPhoneTypes: function () {
      let typesMap = {};
      this.config.profileFields.filter((field) => {
        return field.endsWith('_phone');
      }).map((ptype) => {
        switch (ptype) {
          case 'cell_phone':
            typesMap[ptype] = 'Text Number';
            break;
          case 'home_phone':
            typesMap[ptype] = 'Voice Number';
            break;
          default:
            // shouldn't end up here but whatever
            typesMap[ptype] = capitalize(ptype);
        }
      });
      return typesMap;
    },
  },
  methods: {
    validate: function () {
      this.errors = {};

      if (!this.phoneType) {
        this.errors.phoneType = 'Please select a phone type.';
      }

      if (!this.validationCriteria) {
        this.errors.validationCriteria = 'Please select a validation criteria.';
      }

      return Object.keys(this.errors).length === 0;
    }
  }
}
;
</script>

<style scoped>
ul {
  list-style: none;
}
</style>

